export function mobileMenu() {
    $(".main-nav .menu-btn").on("click", function () {
        $("body").toggleClass("menu-open");
        return false;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileMenu.js